/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { OpenAiChatRequestDisplayModel as AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/open-ai-chat-request-display-model';
import { PreCrawlQuery as AceXFoundPortalCoreCaqOpenAiQueriesPreCrawlQuery } from '../models/ace/xFound/Portal/Core/CAQ/OpenAI/Queries/pre-crawl-query';
import { CheckAnfrageDescriptionQuery as AceXFoundPortalCoreCaqOpenaiQueriesCheckAnfrageDescriptionQuery } from '../models/ace/xFound/Portal/Core/CAQ/openai/Queries/check-anfrage-description-query';
import { GetChatCompletionQuery as AceXFoundPortalCoreCaqOpenaiQueriesGetChatCompletionQuery } from '../models/ace/xFound/Portal/Core/CAQ/openai/Queries/get-chat-completion-query';

@Injectable({
providedIn: 'root',
})

export class OpenAiService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiOpenAiGetChatCompletionPost
   */
  static readonly ApiOpenAiGetChatCompletionPostPath = '/api/OpenAI/GetChatCompletion';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOpenAiGetChatCompletionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiGetChatCompletionPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqOpenaiQueriesGetChatCompletionQuery
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, OpenAiService.ApiOpenAiGetChatCompletionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOpenAiGetChatCompletionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiGetChatCompletionPost(params?: {
    body?: AceXFoundPortalCoreCaqOpenaiQueriesGetChatCompletionQuery
  }): Observable<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel> {

    return this.apiOpenAiGetChatCompletionPost$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel)
    );
  }

  /**
   * Path part for operation apiOpenAiPreCrawlPost
   */
  static readonly ApiOpenAiPreCrawlPostPath = '/api/OpenAI/PreCrawl';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOpenAiPreCrawlPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiPreCrawlPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqOpenAiQueriesPreCrawlQuery
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, OpenAiService.ApiOpenAiPreCrawlPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOpenAiPreCrawlPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiPreCrawlPost(params?: {
    body?: AceXFoundPortalCoreCaqOpenAiQueriesPreCrawlQuery
  }): Observable<void> {

    return this.apiOpenAiPreCrawlPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiOpenAiCheckAnfrageDescriptionPost
   */
  static readonly ApiOpenAiCheckAnfrageDescriptionPostPath = '/api/OpenAI/CheckAnfrageDescription';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOpenAiCheckAnfrageDescriptionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiCheckAnfrageDescriptionPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqOpenaiQueriesCheckAnfrageDescriptionQuery
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, OpenAiService.ApiOpenAiCheckAnfrageDescriptionPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOpenAiCheckAnfrageDescriptionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOpenAiCheckAnfrageDescriptionPost(params?: {
    body?: AceXFoundPortalCoreCaqOpenaiQueriesCheckAnfrageDescriptionQuery
  }): Observable<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel> {

    return this.apiOpenAiCheckAnfrageDescriptionPost$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsOpenAiChatRequestDisplayModel)
    );
  }

}